import { render, staticRenderFns } from "./ImageRecognition.vue?vue&type=template&id=6a48c9a6&scoped=true&"
import script from "./ImageRecognition.vue?vue&type=script&lang=js&"
export * from "./ImageRecognition.vue?vue&type=script&lang=js&"
import style0 from "./ImageRecognition.vue?vue&type=style&index=0&id=6a48c9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48c9a6",
  null
  
)

export default component.exports